import { useLocalizedTabName } from 'components/shared/LegacyWorkspaceTabs/WorkspaceTabDropdownMenuItem/useLocalizedTabName';
import { FC, useCallback } from 'react';
import { DropdownItem } from 'react-bootstrap';
import type { WorkspaceType } from 'state/workspaces/model';
import type { WorkspaceTab } from 'state/workspaces/tabs/tabs.model';

interface MenuItemProps {
  workspaceType: WorkspaceType;

  tab: WorkspaceTab;
  onTabActivated?: (tab: WorkspaceTab) => void;
}

export const MenuItem: FC<MenuItemProps> = ({ tab, onTabActivated, workspaceType }) => {
  const onClicked = useCallback(() => {
    if (onTabActivated !== undefined) {
      onTabActivated(tab);
    }
  }, [tab, onTabActivated]);

  const tabName = useLocalizedTabName({ customizedName: tab.name, tabIndex: tab.count, workspaceType });

  return (
    <DropdownItem role="menuitem" onClick={onClicked} data-e2e="dropdown-item" aria-label={tabName}>
      {tabName}
    </DropdownItem>
  );
};
